import { useEffect, useState } from 'react';

import { Button } from '@selina-finance/ui';
import { useNavigate } from 'react-router-dom';

import CalenderIcon from '@Components/Icons/CalenderIcon';
import ClockIcon from '@Components/Icons/ClockIcon';

import Check3DIcon from '../Icons/Check3DIcon';

import { InfoCard } from './InfoCard';

interface CallInfoProps {
    callDate: string;
    callTime: string;
    navigateLink: string;
    expectCall?: any;
}

export const CallInfo = ({
    callDate,
    callTime,
    navigateLink,
    expectCall,
}: CallInfoProps) => {
    const navigate = useNavigate();

    const handleNavigate = () => {
        navigate(navigateLink);
    };

    const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 1024);
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <>
            <div className='flex flex-col pt-6 sm:pt-0 items-center mb-4'>
                <Check3DIcon
                    width={isMobile ? 31 : 65}
                    height={isMobile ? 47 : 95}
                    className='mb-2'
                />
                <p className='text-28 lg:text-4xl font-sora-bold ml-2'>
                    Your call is booked
                </p>
            </div>
            {expectCall}
            <div className='w-full lg:max-w-400'>
                <div className='flex mb-2'>
                    <InfoCard icon={CalenderIcon} text={callDate} marginRight />
                    <InfoCard icon={ClockIcon} text={callTime} />
                </div>
                <Button
                    className='w-full mb-8 lg:mb-5 lg:max-w-400 rounded-lg'
                    color='tertiary-flat'
                    onClick={handleNavigate}
                >
                    Reschedule
                </Button>
            </div>
        </>
    );
};
